"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ok = ok;
exports.err = err;
exports.isOk = isOk;
exports.isErr = isErr;
exports.mapResult = mapResult;
exports.mapError = mapError;
exports.unwrap = unwrap;
function ok(value) {
    return { ok: true, value };
}
function err(error) {
    return { ok: false, error };
}
function isOk(result) {
    return result.ok;
}
function isErr(result) {
    return !result.ok;
}
function mapResult(result, mapFn) {
    return isOk(result) ? ok(mapFn(result.value)) : err(result.error);
}
function mapError(result, mapFn) {
    return isErr(result) ? err(mapFn(result.error)) : ok(result.value);
}
/**
 * Unwraps a `Result`, throwing when it holds an error. Reserved for
 * composition-root and test code, where an unhandled failure is a defect,
 * not an expected outcome — domain/application code must not call this.
 */
function unwrap(result) {
    if (isErr(result)) {
        throw new Error(`Called unwrap on an error Result: ${JSON.stringify(result.error)}`);
    }
    return result.value;
}
//# sourceMappingURL=result.js.map